import { jsx as _jsx } from "react/jsx-runtime";
import { helpArticles } from '~/utils/helpArticles';
import ExternalLinkButton from './ExternalLinkButton';
export default function AccountantAccessLearnMoreButton(props) {
    const { isVendor } = props;
    return /*#__PURE__*/ _jsx(ExternalLinkButton, {
        openInNewTab: true,
        underline: "hover",
        href: isVendor ? helpArticles.accountantAccess.vendor() : helpArticles.accountantAccess.customer(),
        children: "Learn more about Accountant Access"
    });
}
